import CommentThreadView from '@ckeditor/ckeditor5-comments/src/comments/ui/view/commentthreadview';
import removeCommentIcon from '@ckeditor/ckeditor5-comments/theme/icons/remove-comment.svg';
import pencilIcon from '@ckeditor/ckeditor5-core/theme/icons/pencil.svg';
import { addListToDropdown, createDropdown, Model as ViewModel } from 'ckeditor5/src/ui';
import { Collection } from 'ckeditor5/src/utils';
import { _ } from 'core-js';
import copyIcon from '../../src/styles/fontawesome-5.15.4-web/svgs/regular/copy.svg';
import { addAttachmentLinks, addReactionButtons, CommentAttachment } from '../lib/ckeditorLib';
import './myCommentThreadView.css';
import rangeIcon from './range.svg';
import tagsIcon from './tags.svg';
export default class MyCommentThreadView extends CommentThreadView {
  constructor(locale, model, localUser, config) {
    const { refinedModel, reactionItems, commentAttachments } = MyCommentThreadView.getRefinedModel(model); // super()を呼ぶ前なので、thisは使えない
    super(locale, refinedModel, localUser, config);

    this.i18n = config.editorConfig.i18n;
    this.getIsDialogOpen = config.editorConfig.getIsDialogOpen;
    this.setIsDialogOpen = config.editorConfig.setIsDialogOpen;
    this.setIsCommentTypeDialogOpen = config.editorConfig.setIsCommentTypeDialogOpen;
    this.setIsCommentCopyDialogOpen = config.editorConfig.setIsCommentCopyDialogIsOpen;
    this.setIsCommentRangeDialogOpen = config.editorConfig.setIsCommentRangeDialogOpen;
    this.setChangingCommentThreadId = config.editorConfig.setChangingCommentThreadId;
    this.disabled = config.editorConfig.disabled; // 編集可能かどうか

    // 添付ファイル
    if (!window.commentAttachments) {
      window.commentAttachments = [];
    }
    const allCommentAttachments = [...window.commentAttachments, ...commentAttachments];
    window.commentAttachments = _.uniqBy(allCommentAttachments, 'comment.id'); // comment.idで重複を排除

    // リアクション
    if (!window.reactionItems) {
      window.reactionItems = [];
    }
    const allReactionItems = [...window.reactionItems, ...reactionItems];
    window.reactionItems = _.uniqBy(allReactionItems, 'uuid'); // uuidで重複を排除

    this._setTemplate();

    if (this.length > 0) {
      const commentView = this.commentsListView.commentViews.get(0);
      commentView.isFirst = true;
      this._modifyFirstCommentView();
    } else {
      this.listenTo(this.commentsListView.commentViews, 'add', () => {
        const commentView = this.commentsListView.commentViews.get(0);
        commentView.isFirst = true;
        this._modifyFirstCommentView();
      });
    }

    addAttachmentLinks();
    addReactionButtons();
  }

  _modifyFirstCommentView() {
    // Get the first comment.
    const commentView = this.commentsListView.commentViews.get(0);

    // By default, the comment button is bound to the model state
    // and the buttons are visible only if the current local user is the author.
    // You need to remove this binding and make buttons for the first
    // comment always invisible.
    commentView.removeButton.unbind('isVisible');
    commentView.removeButton.isVisible = false;

    commentView.editButton.unbind('isVisible');
    commentView.editButton.isVisible = false;

    if (this.length > 0 && !this.disabled) {
      // コメントが追加されていて、編集可能な場合は、三点リーダーボタンを表示する
      this.commentTypeDropdownView.buttonView.isVisible = true;
    }
  }

  _setTemplate() {
    // カスタム・テンプレート
    const bind = this.bindTemplate;

    // カスタムヘッダー（三点リーダボタン）
    this.commentTypeDropdownView = this._createActionsDropdown();
    const headerChildParams = {
      tag: 'div',
      attributes: {
        class: 'ck-thread-top-bar ck-comment__actions ck-annotation__actions',
      },
      children: [this.commentTypeDropdownView],
    };
    // デフォルトのコメント
    const defaultChildParams = {
      tag: 'div',
      attributes: {
        class: 'ck-thread__container',
      },
      children: [this.commentsListView, this.commentThreadInputView],
    };
    const childParams = [headerChildParams, defaultChildParams];

    this.setTemplate({
      tag: 'div',

      attributes: {
        class: [
          'ck',
          'ck-thread',
          'ck-reset_all-excluded',
          'ck-rounded-corners',
          bind.if('isActive', 'ck-thread--active'),
        ],
        'data-thread-id': this._model.id,
      },

      children: childParams,
    });
  }

  _createActionsDropdown() {
    const dropdownView = createDropdown(this.locale);

    // 最初は非表示
    dropdownView.buttonView.isVisible = false;
    dropdownView.buttonView.set({
      label: '︙',
      withText: true,
    });
    dropdownView.buttonView.extendTemplate({
      attributes: {
        class: ['ck-button-no-icon'],
      },
    });

    const items = new Collection();

    // 編集ボタン
    const editButtonModel = new ViewModel({
      withText: true,
      label: this.i18n.t('編集'),
      action: 'edit',
      icon: pencilIcon,
    });

    items.add({
      type: 'button',
      model: editButtonModel,
    });

    // 削除ボタン
    const removeButtonModel = new ViewModel({
      withText: true,
      label: this.i18n.t('削除'),
      action: 'delete',
      icon: removeCommentIcon,
    });

    items.add({
      type: 'button',
      model: removeButtonModel,
    });

    // 区分変更ボタン
    const changeTypeButtonModel = new ViewModel({
      withText: true,
      label: this.i18n.t('区分変更'),
      action: 'changeType',
      icon: tagsIcon,
    });

    items.add({
      type: 'button',
      model: changeTypeButtonModel,
    });

    // コピーボタン
    const copyButtonModel = new ViewModel({
      withText: true,
      label: this.i18n.t('コピー'),
      action: 'copy',
      icon: copyIcon,
    });
    items.add({
      type: 'button',
      model: copyButtonModel,
    });

    // 範囲を変更ボタン
    const changeRangeButtonModel = new ViewModel({
      withText: true,
      label: this.i18n.t('範囲を変更'),
      action: 'changeRange',
      icon: rangeIcon,
    });
    items.add({
      type: 'button',
      model: changeRangeButtonModel,
    });

    addListToDropdown(dropdownView, items);

    dropdownView.on('execute', (evt) => {
      const action = evt.source.action;

      if (action == 'edit') {
        // 編集
        this.commentsListView.commentViews.get(0).switchToEditMode();
      } else if (action == 'delete') {
        // 削除
        // remove after confirmation
        if (confirm(this.i18n.t('コメントスレッドを削除しますか?'))) {
          this.fire('removeCommentThread');
        }
      } else if (action == 'changeType') {
        // 区分変更
        this.setChangingCommentThreadId(this._model.id);
        this.setIsDialogOpen(true);
      } else if (action == 'copy') {
        // コピー
        this.setChangingCommentThreadId(this._model.id);
        this.setIsCommentCopyDialogOpen(true);
      } else if (action == 'changeRange') {
        // 範囲を変更
        this.setChangingCommentThreadId(this._model.id);
        this.setIsCommentRangeDialogOpen(true);
      }
    });

    // ドロップダウンの開閉
    dropdownView.on('change:isOpen', (evt, name, isOpen) => {
      // stack contextの影響でz-indexが効かないため、次のコメントスレッドの︙を表示/非表示する
      const buttonElement = evt.source.buttonView.element || null;
      if (buttonElement) {
        const sidebarItemElement = buttonElement.closest('.ck-sidebar-item');
        const nextSidebarItemElement = sidebarItemElement ? sidebarItemElement.nextElementSibling : null;
        if (nextSidebarItemElement) {
          const firstButtonElement = nextSidebarItemElement.querySelector('.ck-button');
          if (firstButtonElement) {
            firstButtonElement.style.display = isOpen ? 'none' : 'inline-flex';
          }
        }
      }
    });

    return dropdownView;
  }
  // コメントデータの整形（データ部分の分離）
  static getRefinedModel(model) {
    const modelComments = model.comments;
    const commentAttachments = [];
    let reactionItems = [];
    for (let i = 0; i < modelComments.length; i++) {
      const comment = modelComments.get(i);
      let commentContent = comment.content;
      // リアクション
      const reactionRegex = new RegExp('<user-reaction>([\\s\\S]*?)</user-reaction>');
      const reactionMatch = comment.content.match(reactionRegex);
      if (reactionMatch && reactionMatch[1]) {
        try {
          reactionItems.push(...JSON.parse(reactionMatch[1]));
        } catch (e) {
          console.error('Failed to parse reactions:', e);
        }
        commentContent = commentContent.replace(reactionRegex, '');
      }
      // 添付ファイルのダウンロードリンク
      // 注意：リアクションコンテンツを削ってしまう可能性があるため、必ずリアクション処理の後に実行すること
      const commentAttachment = new CommentAttachment();
      commentAttachment.setComment(comment);
      const downloadLinkRegex = new RegExp('<p><a href="([^"]+)"[^>]*>(.*?)</a></p>', 'g');
      const matches = Array.from(commentContent.matchAll(downloadLinkRegex));
      if (matches.length > 0) {
        for (const match of matches) {
          const url = match[1];
          const fileName = match[2];
          // 念のため、URLを特定パターンでフィルタリング
          if (url.includes('/api/sections/commentDownload')) {
            commentAttachment.addDownloadItem(url, fileName);
            commentContent = commentContent.replace(match[0], '');
          }
        }
      }
      comment.content = commentContent; // 添付ファイルリンクを削除したコンテンツをセット
      commentAttachments.push(commentAttachment); // 一時退避するデータ
    }
    return {
      refinedModel: model,
      reactionItems: reactionItems,
      commentAttachments: commentAttachments,
    };
  }
}
